import { BusinessSize } from './components/businessSize'
import { Industry } from './components/industry'
import { Portfolio } from './components/portfolio'
import { Province } from './components/province'
import { ScoreLevel } from './components/ScoreLevel'
import { YearsOfOperation } from './components/yearsOfOperation'

export const TYPE_MONEY = [
  {
    label: 'VND',
    value: 2,
  },
  {
    label: 'USD',
    value: 8,
  },
  {
    label: 'EUR',
    value: 14,
  },
]

export const DATA_LIST_DETAIL = [
  {
    label: 'library.savePortfolio.PORTFOLIO',
    key: 'PORTFOLIO',
    component: Portfolio,
    isI18n: true,
  },
  {
    label: 'library.filterSetting.SCORE_LEVEL',
    key: 'SCORE_LEVEL',
    component: ScoreLevel,
    isI18n: true,
  },
  {
    label: 'library.filterSetting.PROVINCE',
    key: 'PROVINCE',
    component: Province,
    isI18n: true,
  },
  {
    label: 'library.filterSetting.INDUSTRY',
    key: 'INDUSTRY',
    component: Industry,
    isI18n: true,
  },
  {
    label: 'library.filterSetting.BUSINESS_SIZE',
    key: 'BUSINESS_SIZE',
    component: BusinessSize,
    isI18n: true,
  },
  {
    label: 'library.filterSetting.YEARS_OF_OPERATION',
    key: 'YEARS_OF_OPERATION',
    component: YearsOfOperation,
    isI18n: true,
  },
]

export const TYPE_TAB_SETTING = {
  PORTFOLIO: 'PORTFOLIO',
  SCORE_LEVEL: 'SCORE_LEVEL',
  PROVINCE: 'PROVINCE',
  INDUSTRY: 'INDUSTRY',
  BUSINESS_SIZE: 'BUSINESS_SIZE',
  YEARS_OF_OPERATION: 'YEARS_OF_OPERATION',
}

export const TYPE_PERIOD = [
  {
    label: 'library.filterSetting.YEAR',
    value: 1,
    isI18n: true,
  },
  {
    label: 'library.filterSetting.QUARTER',
    value: 2,
    isI18n: true,
  },
  {
    label: 'library.filterSetting.MONTH',
    value: 3,
    isI18n: true,
  },
]

export const TYPE_SCORE = [
  {
    label: 'library.filterCompanies.CREDIT_SCORE',
    value: 'creditScore',
    isI18n: true,
  },
  {
    label: 'library.filterCompanies.PERFORMANCE_SCORE',
    value: 'performanceScore',
    isI18n: true,
  },
]

export const TYPE_SCORE_VAlUE = {
  CREDIT_SCORE: 'creditScore',
  PERFORMANCE_SCORE: 'performanceScore',
}

export const TYPE_PERIOD_TIME = {
  CURRENT: 'current',
  PREVIOUS: 'previous',
}

export const DISPLAY_SCORE = {
  CREDIT_CURRENT: 'credit current',
  CREDIT_PREV: 'credit prev',
  PERFORMANCE_CURRENT: 'performance current',
  PERFORMANCE_PREV: 'performance current',
}
